<template>
  <div>
    <div class="jfsc-div">
      <el-popover placement="bottom" width="90%" trigger="click">
        <el-image style="width: 68vw; height: 72vh" :src="url"></el-image>
        <el-button
            slot="reference"
            style="margin-right: 55vw;margin-top: 9vh;height: 5vw;text-align: center;line-height: 0.5vw;font-family:Microsoft YaHei;background-color: #5af4fe;font-weight: bold"
            type="primary"
            round
        ><font color="#1c77c6">积 分 规 则</font></el-button
        >
      </el-popover>
      <div class="score-bar">可消费积分：{{ this.userInfo.nowMoney }} <div  v-if="this.tbUser.balance!==null">青年云平台积分：{{ this.tbUser.balance }}</div></div>
      <!--      <div class="order-bar" @click="toMyOrder()">我的订单>></div>-->
    </div>
    <div>
      <template>
        <div>
          <ProductList
              :good-list="info.productList"
              :modulePrpty="this.modulePrpty"
              :is-sort="false"
          ></ProductList>
        </div>
      </template>
    </div>
    <div>
    </div>
  </div>
</template>

<script>
import debounce from "lodash.debounce";
import {getCategory} from "@api/store";
import {qryProductList} from "@api/store";
import ProductList from "@components/ProductList";
import {getUser} from "@api/user";
import $store from "@/store";

export default {
  name: "GoodsClass",
  components: {ProductList},
  props: {},
  data: function () {
    return {
      userInfo: {},
      tbUser: {},
      tabPosition: "left",
      typeId:'',
      modulePrpty:'',
      category: [],
      navActive: 0,
      activeName: "1",
      search: "",
      lock: false,
      dialogTableVisible: false,
      url: require("@assets/images/classChannel/dhgz.jpg"),
      info: {
        productList: []
      }
    };
  },
  watch: {
    "$route.params.pid": function (n) {
      if (n) {
        this.activeCateId(n);
      }
    }
  },
  mounted: function () {
    this.info.productList=[]
    this.typeId ='';
    console.log(this.$route.params.typeId)
    this.typeId = this.$route.params.typeId
    this.modulePrpty=this.$route.params.modulePrpty
    console.log("goodType:this.modulePrpty"+this.modulePrpty)
    this.User();
    this.getProductList(this.typeId);
    document.addEventListener("scroll", this.onScroll, false);
  },
  methods: {
    User: function () {
      let that = this;
      getUser().then(res => {
        try {
          console.log("用户信息：");
          console.log(res.data);
          that.userInfo = res.data;
          that.tbUser=that.userInfo.tbUser;
        } catch (e) {
          $store.commit("LOGOUT");
        }
      });
    },
    open_rual() {
      this.dialogTableVisible = true;
      console.log("弹窗");
    },
    handleClick(tab) {
      console.log(tab.name);
      this.getProductList(tab.label, tab.name);
    },
    getProductList(type) {
      var params = {
        productType: type
      };
      qryProductList(params).then(res => {
        this.info.productList = res.productList;
        console.log(this.info.productList)
      })
      // self.$axios
      //     .get(`${VUE_APP_API_URL}/api/product/queryProductList?`, {
      //       params: params,
      //       headers: {
      //         Accept:
      //             "text/html,application/xhtml+xml,application/xml;q=0.9,image/avif,image/webp,image/apng,*/*;q=0.8,application/signed-exchange;v=b3;q=0.9"
      //       }
      //     })
      //     .then(response => {
      //       console.log(response.data.productList);
      //       this.info.productList = response.data.productList;
      //     });

      console.log("团课内容");
    },
    activeCateId(n) {
      let index = 0;
      n = parseInt(n);
      if (!n) return;
      this.category.forEach((cate, i) => {
        if (cate.id === n) index = i;
      });

      if (index !== this.navActive) {
        this.asideTap(index);
      }
    },
    loadCategoryData() {
      getCategory().then(res => {
        this.category = res.data;
        this.$nextTick(() => {
          if (this.$route.params.pid) this.activeCateId(this.$route.params.pid);
          else this.onScroll();
        });
      });
    },
    asideTap(index) {
      const top =
          this.$refs.title[index].offsetTop -
          this.$refs.header.offsetHeight -
          window.scrollY;

      this.lock = true;

      window.scrollBy({top, left: 0, behavior: "smooth"});
      this.navActive = index;
    },
    onScroll: debounce(function () {
      if (this.lock) {
        this.lock = false;
        return;
      }
      const headerHeight = this.$refs.header.offsetHeight,
          {scrollY} = window,
          titles = this.$refs.title;
      titles.reduce((initial, title, index) => {
        if (initial) return initial;
        const parent = title.parentNode || title.parentElement;
        if (
            scrollY + headerHeight + 15 <
            title.offsetTop + parent.offsetHeight
        ) {
          initial = true;
          this.navActive = index;
        }
        return initial;
      }, false);
    }, 500),
    toMyOrder() {
      this.$router.push("/order/list");
    }
  },
  activated() {
  },
  beforeDestroy: function () {
    document.removeEventListener("scroll", this.onScroll, false);
  }
};
</script>

<style>
.ipt_num {
  width: 100%;
  display: block;
  line-height: 0.44rem;
  text-align: center;
}

.xxpd_bg {
  text-align: center;
  /*background-image: linear-gradient(-180deg, #f86d6d 0%, #ff2323 100%);*/
  /*background-image: radial-gradient(circle, #f86d6d, #ff2323);*/
  background-image: url("../../assets/images/classChannel/jfsc.jpg");
  /*background-repeat: no-repeat;*/
  background-size: 100% 100%; /*按比例缩放*/
  height: 100%;
}

.last-img {
  height: 35vh;
  width: 100%;
  position: relative;
  text-align: center;
  background-size: 100% 100%; /*按比例缩放*/
  background-image: url("../../assets/images/classChannel/1.jpg");
  margin: 0px;
}

.jfsc-div {
  width: 100% !important;
  height: 20vh !important;
  text-align: center !important;
  background-size: 100% 100% !important; /*按比例缩放*/
  background-image: url("../../assets/images/classChannel/jfsc-top.jpg");
}

.gz-button {
  margin-right: 55vw !important;
  margin-top: 10vh !important;
  width: 100% !important;
  height: 5vw !important;
  text-align: center !important;
  line-height: 1vw !important;
  background-color: #5af4fe;
}

.score-bar {
  margin-top: 1vh;
  margin-left: 10vw;
  text-align: left;
  font-size: small;
  color: #f8f8f8;
  font-weight: bold;
  text-shadow: 2px 2px 4px #000000;
}

.order-bar {
  margin-right: 3vw;
  text-align: right;
  font-size: small;
  color: #f8f8f8;
  font-weight: bold;
  text-shadow: 2px 2px 4px #000000;
}
</style>
